// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"8af81b41","419":"631d3f6c","563":"82cf920d","787":"51c28fd2","942":"570cba33"}[chunkId] + ".chunk.js";
};